
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authentication/register",
      function () {
        return require("private-next-pages/authentication/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authentication/register"])
      });
    }
  